import React from "react";
import { ConsentPolicyType } from "../../../common/enums";
import styles from "./GoogleConsentNotice.module.scss";
import { useAppContext } from "../../../AppContext";
import { classNames } from "primereact/utils";

interface IGoogleConsentNoticeProps {
  className?: string;
  onPolicyClick?: (policyType: ConsentPolicyType) => void;
  isTermsOfUseAvailable: boolean;
}

export const GoogleConsentNotice: React.FC<IGoogleConsentNoticeProps> = ({
  className,
  onPolicyClick,
  isTermsOfUseAvailable,
}) => {
  const { isDesktopOrTablet } = useAppContext();

  let width;

  if (isDesktopOrTablet) {
    width = "350px";
  } else {
    width = "90%";
  }

  return (
    <div
      className={classNames(styles.consentNotice, className)}
      style={{ width, maxWidth: width }}
    >
      <p className={styles.consentText}>
        Продължавайки с Google, вие автоматично се съгласявате с{" "}
        <span
          className={styles.policyLink}
          onClick={() => onPolicyClick?.(ConsentPolicyType.PlannyPrivacyPolicy)}
        >
          политиката за поверителност
        </span>
        {isTermsOfUseAvailable && (
          <>
            ,{" "}
            <span
              className={styles.policyLink}
              onClick={() => onPolicyClick?.(ConsentPolicyType.TenantTermsOfUse)}
            >
              общите условия за ползване
            </span>
          </>
        )}{" "}
        и{" "}
        <span
          className={styles.policyLink}
          onClick={() => onPolicyClick?.(ConsentPolicyType.AutomatedEmails)}
        >
          политиката за автоматизирани имейли
        </span>
        .
      </p>
    </div>
  );
};
